export default "__VITE_ASSET__CDGDxqIF__"